'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _colonyJsContractClient = require('@colony/colony-js-contract-client');

var _colonyJsContractClient2 = _interopRequireDefault(_colonyJsContractClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddExtension = function (_ContractClient$Sende) {
  (0, _inherits3.default)(AddExtension, _ContractClient$Sende);

  function AddExtension() {
    (0, _classCallCheck3.default)(this, AddExtension);
    return (0, _possibleConstructorReturn3.default)(this, (AddExtension.__proto__ || Object.getPrototypeOf(AddExtension)).apply(this, arguments));
  }

  (0, _createClass3.default)(AddExtension, [{
    key: 'estimate',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(inputValues) {
        var args, factoryContract;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                args = this.getValidatedArgs(inputValues);
                _context.next = 3;
                return this._getContract(args);

              case 3:
                factoryContract = _context.sent;
                return _context.abrupt('return', factoryContract.callEstimate('deployExtension', [this.client.contract.address]));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function estimate(_x) {
        return _ref.apply(this, arguments);
      }

      return estimate;
    }()
  }, {
    key: '_sendTransaction',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(args, options) {
        var factoryContract;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._getContract(args);

              case 2:
                factoryContract = _context2.sent;
                return _context2.abrupt('return', factoryContract.callTransaction('deployExtension', [this.client.contract.address], options));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _sendTransaction(_x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return _sendTransaction;
    }()
  }, {
    key: '_getContract',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(args) {
        var factoryContract;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.client.adapter.getContract({
                  contractName: args[0] + 'Factory'
                });

              case 2:
                factoryContract = _context3.sent;

                if (factoryContract) {
                  _context3.next = 5;
                  break;
                }

                throw new Error('No such extension');

              case 5:
                return _context3.abrupt('return', factoryContract);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _getContract(_x4) {
        return _ref3.apply(this, arguments);
      }

      return _getContract;
    }()
  }]);
  return AddExtension;
}(_colonyJsContractClient2.default.Sender);

exports.default = AddExtension;
//# sourceMappingURL=AddExtension.js.map